
const clusterIdOffset = 1000000;

export function calculateClusters(idsAndPositions, gridSteps, gridLatStart, gridLatSize, gridLngStart, gridLngSize)
{
	const gridStepsLat = gridSteps;
	const gridStepsLng = gridSteps;
	const posGrid = {};
	const posLength = idsAndPositions.length;

	const gridLatStep = gridLatSize / gridStepsLat;
	const gridLngStep = gridLngSize / gridStepsLng;

	for(var i = 0; i < posLength; i++)
	{
		const idAndPos = idsAndPositions[i];
		const pos = idAndPos.position;

		const latIndex = Math.floor((pos.lat - gridLatStart) / gridLatStep);
		const lngIndex = Math.floor((pos.lng - gridLngStart) / gridLngStep);

		const existingLatsObj = posGrid[latIndex];
		const latsObj = existingLatsObj ? existingLatsObj : {};

		const existingLngObj = latsObj[lngIndex];
		const lngsObj = existingLngObj ? existingLngObj : {elems:[]};

		lngsObj.elems.push(idAndPos);
		latsObj[lngIndex] = lngsObj;
		posGrid[latIndex] = latsObj;
	}

	var clusters = [];
	var currentId = 0;
	//Calculate mean position for each cluster
	for(var i = 0; i < gridStepsLat; i++)
	{
		const latObj = posGrid[i];

		if(latObj)
		{
			for(var j = 0; j < gridStepsLng ; j++)
			{
				const lngsObj = latObj[j];
				if(lngsObj)
				{
					var accumulatedPos = {
						lat:0, lng:0,
					}

					const compIds = [];

					const elemCount = lngsObj.elems.length;

					for(var k = 0; k < elemCount; k++)
					{
						const thisComp = lngsObj.elems[k]; 
						const thisPos = thisComp.position;
						compIds.push(thisComp.composition_id);
						accumulatedPos.lng += thisPos.lng;
						accumulatedPos.lat += thisPos.lat;
					}

					
					accumulatedPos.lng /= elemCount;
					accumulatedPos.lat /= elemCount;
					const meanPos = {...accumulatedPos};
					/*lngsObj.count = elemCount;
					lngsObj.compIds = compIds;
					*/

					clusters.push({
						meanPos: meanPos,
						count: elemCount,
						compIds: compIds, 
						id: clusterIdOffset + currentId});

					currentId += 1;
				}
			}
		}
	}
	const getMergedCluster = (c1, c2) =>
	{
		const newMeanPos ={
			lng: (c1.meanPos.lng * c1.count + c2.meanPos.lng * c2.count) / (c1.count + c2.count),
			lat: (c1.meanPos.lat * c1.count + c2.meanPos.lat * c2.count) / (c1.count + c2.count),
		}

		return {
			meanPos: newMeanPos,
			count: c1.count + c2.count,
			compIds: [...c1.compIds, c2.compIds],
			id: c1.id,
		}
	}
	for(var i = 0; i < clusters.length; i++)
	{
		//break;
		const clusterI = clusters[i];

		const longitudeFactor = Math.cos(Math.PI / 180 * clusterI.meanPos.lat);

		for(var j = i + 1; j < clusters.length; j++)
		{
			const clusterJ = clusters[j];
			//console.log("comparing clusers " + i + " and " + j + " with latStep: ", clusterI, clusterJ, gridLatStep);
			if(clustersWithinDist(clusterI.meanPos, clusterJ.meanPos, gridLatStep * 0.5, longitudeFactor))
			{
				//console.log("clusters " + i + " and " + j + " are close. With COunts: " + clusterI.count + " and " + clusterJ.count);
				clusters[i] = getMergedCluster(clusterI, clusterJ);
				clusters.splice(j,1);
				i = -1;
				break;

			}
		}
	}


	const clusterCount = clusters.length;
	const loneIds = [];
	for (var i = clusterCount - 1; i >= 0; i--) {
		const cluster = clusters[i];
		
		if(cluster.count > 1)
		{
			cluster
		}
		else
		{
			loneIds.push(cluster.compIds[0]);
			clusters = clusters.filter((c)=>{return c !=cluster});
		}
	}



	return {
		clusters:clusters,
		loneIds:loneIds,
	};
	

	//return posGrid;
}
const getDist = (latA, lngA, latB, lngB, longitudeFactor) =>
{
	const dist = Math.sqrt(Math.pow(latA-latB, 2) + Math.pow((lngA-lngB) * longitudeFactor, 2));
	return dist;
}

const clustersWithinDist = (c1, c2, dist, longitudeFactor) =>
{
	const difLat = Math.abs(c1.lat - c2.lat);

	if(difLat > dist)
	{
		return false;
	}

	const difLngCorrected =  Math.abs(c1.lng - c2.lng) * longitudeFactor;

	if(difLngCorrected > dist)
	{
		return false;
	}

	return getDist(c1.lat, c1.lng, c2.lat, c2.lng, longitudeFactor) < dist;

}


// WEBPACK FOOTER //
// ./js/Clustering.js